module.exports = __webpack_public_path__ + "img/bp_button_normal_hqcs.8278e608.png";